<script setup>
const props = defineProps({
	time: {
		type: String,
		required: true,
		default: "00:00:00",
	},
});
</script>
<template>
	<div class="quiz-slide-timer">
		<div class="quiz-slide-timer__inner">
			<div class="quiz-slide-timer__img">
				<img class="full-img" width="131" height="129" src="@/assets/img/games/shape_question.webp" alt="изображение" />
			</div>
			<div class="quiz-slide-timer__info">
				<p class="quiz-slide-timer__text">🔥 Подарок сгорит через:</p>
				<span class="quiz-slide-timer__time">{{ time }}</span>
				<span class="quiz-slide-timer__time --slide">🔥 {{ time }}</span>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-slide-timer {
	@extend .base-bg;
	width: fit-content;
	border: 1px solid var(--border-accent-2-4);
	border-radius: 2.4rem;
	padding: 3rem 4rem 3rem 1.8rem;
	overflow: hidden;
	@media (max-width: vars.$x480) {
		width: 100%;
		padding: 2rem 2rem 2rem 1rem;
	}
	&.--big {
		display: grid;
		place-content: center;
		padding: 1rem;
		border-radius: 4rem;
		width: 54.9rem;
		height: 54.9rem;
		@media (max-width: vars.$x480) {
			border-radius: 2.4rem;
			width: 100%;
			height: 26.1rem;
		}
		.quiz-slide-timer {
			&__img {
				width: 28.1rem;
				height: 27.6rem;
				@media (max-width: vars.$x480) {
					width: 15.7rem;
					height: 15.4rem;
				}
			}
			&__inner {
				flex-direction: column;
				gap: 9rem;
				@media (max-width: vars.$x480) {
					gap: 2.4rem;
				}
			}
			&__info {
				display: flex;
				align-items: center;
			}
			
			&__time {
				padding-left: 1rem;
				@media (max-width: vars.$x480) {
					padding-left: 0.5rem;
				}
				
			}
		}
	}
	&.--decor {
		@media (max-width: vars.$x480) {
			background-image: url("@/assets/img/games/quiz_slide_timer_bg.png");
			background-repeat: no-repeat;
			background-position: 0px 0px; /* x y*/
			background-size: cover; /* w h*/
		}
	}

	&.--prize-slide {
		display: grid;
		place-content: center;
		padding: 1rem;
		border-radius: 4rem;
		width: 100%;
		height: 100%;
		aspect-ratio: 1 / 1;
		@media (max-width: vars.$l) {
			// height: 100%;
        	// aspect-ratio: 1 / 1;
		}
		@media (max-width: vars.$x480) {
			border-radius: 2.4rem;
			// width: 100%;
			// height: 100%;
        	// aspect-ratio: 1 / 1;
		}
		.quiz-slide-timer {
			&__img {
				width: 18.3rem;
				height: 18.1rem;
				@media (max-width: vars.$x480) {
					width: 8rem;
					height: 7.9rem;
				}
			}
			&__inner {
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
				gap: 1rem;
				@media (max-width: vars.$x480) {
					gap: 2.4rem;
				}
			}
			&__info {
				display: flex;
				align-items: center;
			}
			&__text {
				display: none;
			}
			&__time {
				padding-left: 0rem;
				display: none;
				@media (max-width: vars.$x480) {
					padding-left: 0rem;
				}

				&.--slide {
					display: block;
				}
			}
		}
	}

	&__inner {
		display: flex;
		align-items: center;
		gap: 2rem;
	}

	&__img {
		width: 13.1rem;
		height: 12.9rem;
		flex-shrink: 0;
		@media (max-width: vars.$x480) {
			width: 8rem;
			height: 7.9rem;
		}
	}

	&__info {
	}

	&__text {
		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
		}
	}

	&__time {
		display: block;
		font-weight: 700;
		font-size: 2rem;
		line-height: 120%;
		color: var(--text-accent-2-100);
		padding-left: 2.6rem;
		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
		}
		&.--slide {
			display: none;
		}
	}
}
</style>
